module.exports = __webpack_public_path__ + "static/media/Intersection 21.3bf72779.png";